module.exports = __webpack_public_path__ + "static/media/social_sprite.5e02afbc.svg";